import React from 'react';
import { NextRouter } from 'next/router';
import HBBusService from 'src/services/hbBusService';

export const sameRedirectDisabler = (
  router: NextRouter,
  path: string,
  e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  event: any
) => {
  const hbBus = HBBusService();
  hbBus.footerClickEvent(event);

  if (router.pathname === path) e.preventDefault();
};
